import { normalizeAuthToken } from './adminFormatting';

const endpointpath = process.env.REACT_APP_API_BASE_URL;

const filenameFromResponse = (response, fallback) => {
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
  return match ? decodeURIComponent(match[1]) : fallback;
};

// The PDF routes are behind the admin JWT, so a plain anchor href cannot be
// used: the file is fetched with the auth header and saved from the blob.
const downloadPdf = async (path, fallbackName) => {
  const token = normalizeAuthToken(localStorage.getItem('token'));
  if (!token) throw new Error('Session expired. Please log in again.');

  const response = await fetch(`${endpointpath}${path}`, {
    method: 'GET',
    headers: { Authorization: token },
  });

  if (!response.ok) {
    throw new Error(`Could not generate the PDF (${response.status}).`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filenameFromResponse(response, fallbackName);
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};

export const downloadProposalPdf = (proposalID) =>
  downloadPdf(`/api/admin/proposals/${encodeURIComponent(proposalID)}/pdf`, `proposal-${proposalID}.pdf`);

export const downloadProjectPdf = (projectID) =>
  downloadPdf(`/api/admin/projects/${encodeURIComponent(projectID)}/pdf`, `project-${projectID}.pdf`);
